import { Line } from "react-chartjs-2"
import React, { FunctionComponent } from "react"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { waldSample } from "@components/Distribution/WaldDistributionChart/wald.calc"

interface Props {
  loc: number
  scale: number
  lbound?: number
  ubound?: number
}

export const WaldDistributionChart: FunctionComponent<Props> = (props) => {
  const data = waldSample(props.loc, props.scale, props.lbound, props.ubound)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    datasets: [
      {
        data,
        fill: false,
        tension: 0.1,
      },
    ],
  }

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: "linear",
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        title: {
          display: true,
          text: "Probability Density",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
